import React, { useEffect, useState } from "react";
import LiveIcon from "../../../../../../../assets/images/Souvenir/live.png";
import axios from "axios";
import AuctionNav from "../AuctionNav/AuctionNav";
import "./AuctionLive.css";
import LoaderPost from "../../../../../../Reuseable/LoaderPost";
import ProductCard from "./ProductCard";

const LiveNowAuction = () => {
  const [loading, setLoading] = useState(true);

  const [liveProduct, setLiveProduct] = useState([]);

  useEffect(() => {
    axios.get(`/api/admin/live/allProduct`).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        setLiveProduct(res.data.products);
      }
    });
  }, []);

  return (
    <>
      <AuctionNav />

      <div className="d-flex mb-4  head-line p-3">
        <div className=" d-flex">
          <img src={LiveIcon} className=" SouvenirIcon" alt="" />
        </div>
        <div className=" d-flex text-light fw-bold mt-1 mx-3 ">Live Now</div>
      </div>

      {loading ? <LoaderPost /> : <ProductCard data={liveProduct} />}
    </>
  );
};

export default LiveNowAuction;
